<template>
  <div class="conversations-col d-flex align-center justify-center ga-4">
    <v-switch
      v-model="status"
      color="primary"
      class="custom-switch"
      :disabled="item.is_converted === 1"
    />
  </div>
</template>

<script>
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General.js";
export default {
  name: "ConversationsCol",
  props: ["item"],
  data() {
    return {
      store: useGeneralStore(),
      
    };
  },
  computed: {
    status: {
      get() {
        return this.item.is_converted === 1;
      },
      set(value) {
        if (value) {
          this.toggle(this.item.id);
        }
      },
    },
  },
  methods: {
    toggle(id) {
      apiClient
        .post("/leads-managment/convert-lead", {
          lead_id: id,
          is_converted: 1,
        })
        .then(() => {
          this.item.is_converted = 1; // ✅ تحديث القيمة محليًا
          this.store.showSnackbar("Lead converted successfully", "success");
        })
        .catch(() => {
          this.store.showSnackbar("Lead conversion failed", "error");
        });
    },
  },
};
</script>
<style scoped>
.custom-switch.v-input.v-input--disabled .v-switch__thumb,
.custom-switch.v-input.v-input--disabled .v-switch__track {
  background-color: #9e9e9e !important; /* رصاصي */
  opacity: 1 !important; /* تمنع البهتان */
}
</style>
